var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar-item has-dropdown",class:{ 'is-hoverable': _vm.isHoverable, 'is-active': _vm.isDropdownActive }},[_c('a',{staticClass:"navbar-link is-arrowless",class:{ 'is-hidden-touch': _vm.hideOpenOnMobile },on:{"click":_vm.toggle}},[_vm._t("default")],2),_vm._t("dropdown")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }